/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
import React, { useState } from 'react';
import Statistiques from '../components/Statistiques';
import PartenairesAccordion from '../components/PartenairesAccordion';
import './final.css';

import logo from './new_logo.png';

const Page1 = () => {
const [showPartenaires, setShowPartenaires] = useState(false);
        const stats = {
        curieux: 45,
                innovations: 30,
                besoins: 20,
                apporteurs: 50,
                soutiens: 10,
                promoteurs: 15
        };
        const objectives = {
        curieux: 100,
                innovations: 80,
                besoins: 60,
                apporteurs: 100,
                soutiens: 50,
                promoteurs: 40
        };
        return (
                <div className="container">
    <header className="header">
        <div className="logo">
           <img
  src={logo}
  alt="Logo MyBusinessPartner : là ou les talents et les apporteurs converges"
  className="logo-img"
/>

            <h1>myBusinessPartner</h1>
        </div>
        <p className="tagline">
            Connecter talents, besoins, financements et savoir-faire.<br/>
            Participe et découvre les opportunités
        </p>
        <button
          className="cta-button"
          onClick={() => setShowPartenaires(prev => !prev)}
        >
          {showPartenaires
            ? '← Retour aux statistiques'
            : 'Je souhaite participer'}
        </button>
            
    </header>
    {showPartenaires ? (
                <PartenairesAccordion onBack={() => setShowPartenaires(false)} />
                ) : (
                <Statistiques stats={stats} objectives={objectives} />
                )}
</div>
                );
        };

export default Page1;

